export default async function toggleFullScreen(fullscreen?: boolean, element?: HTMLElement): Promise<void> {
	const doc: any = document;
	const docEl: any = document.documentElement;
	const targetElement: any = element || docEl;

	const requestFullScreen =
		targetElement.requestFullscreen ||
		targetElement.mozRequestFullScreen ||
		targetElement.webkitRequestFullScreen ||
		targetElement.msRequestFullscreen;

	const exitFullScreen =
		doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

	if (
		(fullscreen === undefined || fullscreen) &&
		!doc.fullscreenElement &&
		!doc.mozFullScreenElement &&
		!doc.webkitFullscreenElement &&
		!doc.msFullscreenElement
	) {
		try {
			await requestFullScreen.call(targetElement);
		} catch (error) {
			// cannot enter fullscreen, ignore
		}
	} else if (fullscreen === undefined || !fullscreen) {
		try {
			await exitFullScreen.call(doc);
		} catch (error) {
			// cannot exit fullscreen, ignore
		}
	}
}
